export default __webpack_public_path__ + "static/media/hogwarts-3.bfa74dab.png";